export default "__VITE_ASSET__B6l2rVVp__"